import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import SongItem from '../SongItem/SongItem';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import PopUp from '../../../../Shared/Popup/PopUp';
import "./removeSong.scss";
import trash from './images/trash.svg';
import {deleteSong } from '../../fundialSlice';


const RemoveSong = (props) => {

    function removeSongBtn(){
        props.deleteSong({subscriber: props.subscribers.cli , productId: props.audio.id  });
        props.close();
    }

    return (
        <PopUp className="fundial-remove-song-popup" showPopUp={props.show} onClose={props.close}>
            <div className="remove-song-wrapper" >
                <div className="title">
                    <Image src={trash} className="trash-icon" />
                    <h1>הסרת שיר </h1>
                </div>
                <div className="chosen-song">
                    {props.isDefaultSong && <p className="sub-title">בחרת להסיר השיר ברירת מחדל</p>}
                    {!props.isDefaultSong && <p className="sub-title">בחרת להסיר את השיר</p>}
                    <SongItem isDisplayPlayer={false} playerSize={87} isDetailsFromLeft={true} audio={props.audio} onClickSong={()=> {}} ></SongItem>
                </div>
                <div className="description">
                    {props.isDefaultSong && 
                        <p>
                            לאחר אישור ביצוע הפעולה מי שיתקשר אליך
                            ישמע את כל הפליליסט המעולה שלך.
                            כמובן שניתן לבחור שיר אחר כברירת מחדל
                        </p>
                    }
                    {!props.isDefaultSong && 
                        <p>
                        לאחר אישור ביצוע הפעולה אנשי הקשר
                        אליהם משויך השיר ישמעו את
                        שיר ברירת המחדל
                        </p>
                    }
                </div>
                <div className="btn-wrapper">
                    <button onClick={()=> {props.close()}} className="cancel-btn">ביטול</button>
                    <BtnSubmit onclick={() => removeSongBtn()} text="אישור הסרה" formid="fundial-remove-song"></BtnSubmit>
                </div>
            </div>
        </PopUp> 
    ) ;
}

const mapStateToProps = (state) => {
    return {
        subscribers: state.fundialPage.selectedSubscriber,
    };
  };
  
  const mapDispatchToProps = {
    deleteSong
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(RemoveSong);


